// src/components/SubscriptionModal.js (or your component path)
import { Modal, Button, Form, Radio, Alert } from "antd";
import React from "react";

const SubscriptionModal = ({
  isSubscriptionModalOpen,
  onClose,
  openSuccessModal,
  openFailedModal,
  openLoadingModal,
  closeLoadingModal,
  refreshSubscription,
  currentPlan,
}) => {
  const [form] = Form.useForm();
  const [error, setError] = React.useState(null);
  const [selectedPlan, setSelectedPlan] = React.useState(currentPlan?.planName || '');

  const handleSubmit = async () => {
    try {
      setError(null);
      openLoadingModal();
      
      const values = await form.validateFields();
      
      // SIMULATE API CALL (Replace with real API)
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      closeLoadingModal();
      onClose();
      openSuccessModal();
      refreshSubscription();
    } catch (err) {
      closeLoadingModal();
      setError(err.message || 'Failed to update subscription');
      openFailedModal();
    }
  };

  const subscriptionPlans = [
    { name: 'Basic', price: '$10/month', value: 'basic' },
    { name: 'Pro', price: '$20/month', value: 'pro' },
    { name: 'Enterprise', price: '$50/month', value: 'enterprise' },
  ];

  return (
    <Modal
      title={currentPlan ? "Manage Subscription" : "Subscribe Now"}
      open={isSubscriptionModalOpen}
      onCancel={onClose}
      footer={[
        <Button key="back" onClick={onClose}>Cancel</Button>,
        <Button key="submit" type="primary" onClick={handleSubmit}>
          {currentPlan ? "Update Subscription" : "Subscribe"}
        </Button>,
      ]}
    >
      {error && <Alert message={error} type="error" showIcon style={{ marginBottom: 16 }} />}
      
      <Form form={form} layout="vertical">
        <Form.Item
          name="plan"
          label="Select a subscription plan"
          rules={[{ required: true, message: 'Please select a plan' }]}
          initialValue={currentPlan?.planName || ''}
        >
          <Radio.Group onChange={(e) => setSelectedPlan(e.target.value)}>
            {subscriptionPlans.map((plan) => (
              <Radio key={plan.value} value={plan.value}>
                <div>
                  <strong>{plan.name}</strong>
                  <div>{plan.price}</div>
                  {plan.value === selectedPlan && currentPlan && (
                    <div style={{ color: 'green' }}>Current Plan</div>
                  )}
                </div>
              </Radio>
            ))}
          </Radio.Group>
        </Form.Item>
      </Form>
      
      {currentPlan && (
        <div style={{ marginTop: 16 }}>
          <Alert
            message="Subscription Note"
            description="Changing your plan may affect your billing cycle."
            type="info"
            showIcon
          />
        </div>
      )}
    </Modal>
  );
};

export default SubscriptionModal;